import React from 'react';
import { DetailSection, DetailRow, LinkChip, ChipGrid, StatusBadge } from './detail-primitives';

const TeacherDetail = ({ data, onOpen }) => (
  <div className="space-y-3" data-testid="teacher-detail-body">
    <DetailSection title="بطاقة المعلم">
      <DetailRow label="الاسم" value={data.full_name} testId="teacher-full-name" />
      <DetailRow label="الدور" value={data.role} />
      <DetailRow label="الحالة" value={<StatusBadge status={data.status} />} />
      <DetailRow label="الجوال" value={data.phone_number} testId="teacher-phone" />
      <DetailRow label="واتساب" value={data.whatsapp_number} />
      <DetailRow label="البريد" value={data.email} />
      <DetailRow label="تاريخ الانضمام" value={(data.joined_at || '').slice(0, 10)} />
    </DetailSection>

    <DetailSection title="ملخص التدريس">
      <DetailRow label="إجمالي الطلاب" value={data.total_students ?? 0} testId="teacher-total-students" />
      <DetailRow label="عدد القاعات" value={(data.classrooms || []).length} testId="teacher-total-classrooms" />
      <DetailRow label="البرامج" value={(data.programs || []).join('، ') || '—'} />
      <DetailRow label="المستويات" value={(data.levels || []).join('، ') || '—'} />
    </DetailSection>

    <DetailSection title={`القاعات (${(data.classrooms || []).length})`}>
      <ChipGrid empty="لا توجد قاعات مرتبطة بهذا المعلم.">
        {(data.classrooms || []).map((c) => (
          <LinkChip
            key={c.id}
            kind="classroom"
            id={c.id}
            onOpen={onOpen}
            label={c.classroom_name || c.classroom_code || 'قاعة'}
            sub={[c.book_name, c.schedule, `${c.current_students || 0} طالب`].filter(Boolean).join(' • ')}
            testId={`teacher-classroom-link-${c.id}`}
          />
        ))}
      </ChipGrid>
    </DetailSection>
  </div>
);

export default TeacherDetail;
